import { useEffect, useRef } from 'react';

const PARTICLE_INTERVAL_MS = 35;
const MAX_PARTICLES = 70;

function CursorTrail() {
  const layerRef = useRef(null);

  useEffect(() => {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const coarsePointerQuery = window.matchMedia('(pointer: coarse)');
    const isTrailDisabled = () => (
      reducedMotionQuery.matches
      || coarsePointerQuery.matches
      || window.innerWidth < 768
    );

    const layer = layerRef.current;
    let lastParticleAt = 0;

    const handleMouseMove = (event) => {
      if (isTrailDisabled()) {
        return;
      }

      if (event.target.closest?.('.terminal-shell')) {
        return;
      }

      const now = window.performance.now();

      if (now - lastParticleAt < PARTICLE_INTERVAL_MS) {
        return;
      }

      lastParticleAt = now;

      if (!layer) {
        return;
      }

      const particle = document.createElement('span');
      const size = 3 + Math.random() * 3;

      particle.className = 'cursor-particle';
      particle.style.left = `${event.clientX}px`;
      particle.style.top = `${event.clientY}px`;
      particle.style.setProperty('--particle-size', `${size}px`);

      layer.appendChild(particle);

      while (layer.childNodes.length > MAX_PARTICLES) {
        layer.firstChild?.remove();
      }

      particle.addEventListener('animationend', () => {
        particle.remove();
      }, { once: true });
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      layer?.replaceChildren();
    };
  }, []);

  return <div className="cursor-trail" ref={layerRef} aria-hidden="true" />;
}

export default CursorTrail;
